import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {ExcTranslation} from 'exc-core-v2';

@Component({
  selector: 'app-searchbar',
  templateUrl: './app-searchbar.component.html',
  styles: [
  ]
})
export class AppSearchbarComponent extends ExcTranslation implements OnInit {
  @Input() resultCount = 0;
  @Input() totalCount = 0;
  @Input() placeholder = this.getGlobal('SearchPlaceholder');
  @Input() searchOnEnter = false;

  @Input() iconClass = 'fas fa-search';
  @Input() inputStyle = '';
  @Input() inputDelay = 200;

  @Output() search = new EventEmitter<string>();
  @Output() searchReset = new EventEmitter<string>();


  @Input() set searchTextOverride(text: string) {
    if (text) {
      this._searchText = text;
    } else {
      this._searchText = '';
    }
  }

  @ViewChild('searchInput') searchInput!: ElementRef;

  private searchTextSubject = new Subject<string>();
  private _searchText = '';

  get searchText(): string {
    return this._searchText;
  }

  set searchText(value: string) {
    this._searchText = value;
    this.searchTextSubject.next(value);
  }

  constructor() {
    super();
  }

  ngOnInit(): void {
    if (!this.searchOnEnter) {
      this.searchTextSubject.pipe(
        debounceTime(this.inputDelay),
        distinctUntilChanged()
      ).subscribe(value => {
        this.search.emit(this.searchText);
      });
    }
  }

  resetSearch(): void {
    this.searchText = '';
    this.setFocus();
    this.searchReset.emit();
  }

  setFocus(): void {
    (this.searchInput.nativeElement as HTMLElement).focus();
  }
}
